"use strict";
(function (Drupal, once) {
    Drupal.behaviors.openExpandedMenu = {
        previousClickedElementID: '',
        attach: function (context) {
            // Get the logo and menu wrapper
            const logoAndMenuWrapper = document.querySelector('.js-logo-and-menu-wrapper');
            // Get all top level menu items
            const topLevelMenuItems = document.querySelectorAll('.js-top-level-menu-item');
            // Get the toggle cta element
            const toggleCTAElement = document.querySelector('.js-toggle-call-to-action');
            once('openExpandedMenu', '.js-top-level-menu-item', context).forEach(function (element) {
                element.addEventListener('click', function (event) {
                    if (Drupal.behaviors.openExpandedMenu
                        .previousClickedElementID === element.getAttribute('id')) {
                        Drupal.behaviors.closeExpandedMenu.closeAllExpandedMenus();
                        Drupal.behaviors.openExpandedMenu.previousClickedElementID =
                            null;
                        // Reset the top level menu chevrons
                        Drupal.behaviors.resetTopLevelMenuChevrons.attach(document, Drupal.settings);
                        if (toggleCTAElement) {
                            // Remove the toggle call to action
                            toggleCTAElement.classList.remove('hidden');
                        }
                        // Remove new hover classes to the top level menu items
                        topLevelMenuItems.forEach((topLevelMenuItem) => {
                            topLevelMenuItem.classList.remove('hover:rounded-b-none', 'hover:rounded-t-3xl', 'focus-visible:rounded-b-none', 'focus-visible:rounded-t-3xl', 'pb-8');
                        });
                        // Add align-items: flex-end to the logo and menu wrapper
                        if (logoAndMenuWrapper) {
                            // Remove items-center
                            logoAndMenuWrapper.classList.add('items-center');
                            // Add items-end
                            logoAndMenuWrapper.classList.remove('items-end');
                        }
                    }
                    // If the previous clicked element is not the same as the currently clicked element
                    else {
                        // Reset the top level menu chevrons
                        Drupal.behaviors.resetTopLevelMenuChevrons.attach(document, Drupal.settings);
                        // Get all the js-expanded-menu elements
                        const expandedMenuElements = document.querySelectorAll('.js-expanded-menu');
                        // Remove all the js-expanded-menu elements from the DOM
                        expandedMenuElements.forEach(function (expandedMenuElement) {
                            expandedMenuElement.remove();
                        });
                        // Get the chevron svg's inside of the element
                        const svgs = element.querySelectorAll('svg');
                        svgs.forEach((svg) => {
                            // Rotate the svg 180 degrees
                            svg.style.transform = 'rotate(180deg)';
                        });
                        // Check if the next element is a template element
                        if (element.nextElementSibling instanceof
                            HTMLTemplateElement) {
                            const expandedMenuTemplate = element.nextElementSibling;
                            // Clone it
                            const expandedMenu = expandedMenuTemplate.content.cloneNode(true);
                            // Insert it after the element
                            element.after(expandedMenu);
                            if (toggleCTAElement) {
                                // Remove the toggle call to action
                                toggleCTAElement.classList.add('hidden');
                            }
                            // Disable scroll on body
                            document.body.style.overflow = 'hidden';
                            // Re-attach the closeExpandedMenu behaviour now that the expanded menu is in the DOM
                            Drupal.behaviors.closeExpandedMenu.attach(document, Drupal.settings);
                            // Add new hover classes to the top level menu items
                            topLevelMenuItems.forEach((topLevelMenuItem) => {
                                console.log(topLevelMenuItem.nodeName);
                                // Check if the top level menu item is a button element
                                topLevelMenuItem.classList.add('hover:rounded-b-none', 'hover:rounded-t-3xl', 'focus-visible:rounded-b-none', 'focus-visible:rounded-t-3xl', 'pb-8');
                            });
                            // Add align-items: flex-end to the logo and menu wrapper
                            if (logoAndMenuWrapper) {
                                // Remove items-center
                                logoAndMenuWrapper.classList.remove('items-center');
                                // Add items-end
                                logoAndMenuWrapper.classList.add('items-end');
                            }
                        }
                        if (element.getAttribute('id')) {
                            Drupal.behaviors.openExpandedMenu.previousClickedElementID =
                                element.getAttribute('id');
                        }
                    }
                });
            });
        },
    };
})(Drupal, once);
